var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-size-1920"},[_c('kegel-header'),_c('kegel-about'),_c('kegel-proven-benefits'),_c('kegel-motivation'),_c('kegel-slider'),_c('kegel-programm'),_c('kegel-questions'),_c('kegel-pre-footer'),_c('kegel-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }